/* pos/actions */
import { action } from "typesafe-actions";
import { Pos, PosActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(PosActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Pos) =>
  action(PosActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(PosActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Pos | null) => unknown
) => action(PosActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Pos) =>
  action(PosActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(PosActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(PosActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(PosActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(PosActionTypes.DELETE_ERROR, error);

export const downloadRequest = (
  params: { },
  callback?: (err?: string | null, data?: any | null) => unknown
) => action(PosActionTypes.DOWNLOAD_REQUEST, { params, callback });
